/**
* @license Copyright (c) Microsoft Corporation. All rights reserved.
*/
export function normalizeGuid(id) {
    if (id && id.length > 0) {
        id = id.trim();
        if (id.startsWith("{")) {
            id = id.slice(1);
        }
        if (id.endsWith("}")) {
            id = id.slice(0, -1);
        }
    }
    return id === null || id === void 0 ? void 0 : id.toLocaleLowerCase();
}
export function getFormControlLabel(controlName) {
    try {
        return window.Xrm.Page.ui.controls.get(controlName).getLabel() || controlName;
    }
    catch (error) {
        return controlName;
    }
}
export function getAttribute(attributeName) {
    var _a;
    try {
        return (_a = window.Xrm.Page.getAttribute(attributeName)) === null || _a === void 0 ? void 0 : _a.getValue();
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
